export interface PricingPlan {
  id: 'free';
  name: 'Free';
  basePrice: 0;
  includedWorkers: null;
  includedLocations: null;
  overagePrice: 0;
  locationOveragePrice: 0;
}

/**
 * Public core-workforce pricing. Acceleration and advanced extras are quoted
 * independently and must never be inferred from workforce capacity in React.
 */
export const PRICING_PLANS: PricingPlan[] = [{
  id: 'free',
  name: 'Free',
  basePrice: 0,
  includedWorkers: null,
  includedLocations: null,
  overagePrice: 0,
  locationOveragePrice: 0,
}];

export function selectPlanForWorkerCount(_workerCount: number): PricingPlan {
  return PRICING_PLANS[0];
}

export function calculateMonthlyCost(_workerCount: number, _locationCount = 1): {
  plan: PricingPlan;
  basePrice: number;
  overagePrice: number;
  locationOveragePrice: number;
  totalPrice: number;
} {
  return {
    plan: PRICING_PLANS[0],
    basePrice: 0,
    overagePrice: 0,
    locationOveragePrice: 0,
    totalPrice: 0,
  };
}
